import { Grid, Typography } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { useGetVotacoesData } from "data/api/gestao/clickup/get-votacoes-data"
import { useCallback, useEffect, useState } from "react"
import { useToastSaurus } from "services/app"
import { useStyles } from "./roadmap-periodo-styles"
import { toDateString } from "utils/to-date"

interface ResultadoGetVotacoesData {
    inicio: Date
    fim: Date
}

const dataFormatada = (data: Date | undefined): string => {
    if (!data) return ''
    return toDateString(new Date(data)) ?? ''
}

export const RoadmapPeriodo = () => {
    const { getVotacoesData, carregando } = useGetVotacoesData()
    const { showToast } = useToastSaurus()
    const classes = useStyles()

    const [data, setData] = useState<ResultadoGetVotacoesData | null>(null)

    const handleGetVotacoesData = useCallback(async () => {
        try {
            const res = await getVotacoesData()
            if (res.erro) throw res.erro

            const resultado = res.resultado?.data as ResultadoGetVotacoesData

            if (resultado) setData(resultado)
        } catch (err: any) {
            showToast('error', err.message)
        }
    }, [getVotacoesData, showToast])

    useEffect(() => {
        handleGetVotacoesData()
    }, [handleGetVotacoesData])

    return (
        <Grid>
            <Typography variant="body1" className={classes.text}>
                Período: {
                    carregando
                        ? <Skeleton animation="wave" variant="text" width={130} height={40} />
                        : <span>{dataFormatada(data?.inicio)} - {dataFormatada(data?.fim)}</span>
                }
            </Typography>
        </Grid>
    )
}